<template>
  <div class="expert">
    <el-button type="primary" @click="openDialog()">新增数据</el-button>

    <el-table border :data="tableData" v-loading="loading" style="width: 100%">
      <el-table-column prop="SortOrder" label="排序" width="80"></el-table-column>
      <el-table-column prop="Photo" label="头像" width="100">
        <template slot-scope="scope">
          <img
            v-if="scope.row.Photo"
            class="table-thumb"
            :src="$img(scope.row.Photo)"
            alt="头像"
          />
          <span v-else class="muted">—</span>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="姓名" width="120"></el-table-column>
      <el-table-column prop="Title" label="职位" width="160"></el-table-column>
      <el-table-column prop="Bio" label="简介">
        <template slot-scope="scope">
          <span class="bio-cell">{{ scope.row.Bio }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            @click="handleEdit(scope.$index, scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="handleDelete(scope.$index, scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="total > pageSize"
      class="pager"
      layout="prev, pager, next, jumper, total"
      :page-size="pageSize"
      :current-page.sync="page"
      :total="total"
      background
      @current-change="loadData"
    />

    <el-dialog title="核心技术人员编辑" :visible.sync="dialogFormVisible" width="560px">
      <el-form :model="formData">
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="formData.Name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职位" :label-width="formLabelWidth">
          <el-input v-model="formData.Title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="头像" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            :action="$uploadAction"
            :headers="headers"
            :show-file-list="false"
            :on-success="handleSuccess"
          >
            <img v-if="formData.Photo" :src="$img(formData.Photo)" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input-number v-model="formData.SortOrder" :min="0" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="个人简介" :label-width="formLabelWidth">
          <el-input
            v-model="formData.Bio"
            type="textarea"
            :rows="4"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateOrModify()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      dialogFormVisible: false,
      formLabelWidth: "100px",
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      formData: {
        Id: 0,
        Name: "",
        Title: "",
        Photo: "",
        Bio: "",
        SortOrder: 0,
        CreateTime: new Date()
      },
      options: {},
      headers: {}
    };
  },
  mounted() {
    const token = "Bearer " + sessionStorage.getItem("token");
    this.options = {
      headers: { Authorization: token }
    };
    this.headers = { Authorization: token };
    this.loadData();
  },
  watch: {
    page() {
      this.loadData();
    }
  },
  methods: {
    handleSuccess(response, file, fileList) {
      this.formData.Photo = this.$uploadResult(response);
    },
    loadData() {
      this.loading = true;
      this.$http
        .get(`Expert?page=${this.page}&size=${this.pageSize}`, this.options)
        .then(response => {
          const data = response.data || {};
          this.tableData = data.Items || data.items || [];
          this.total = data.Total || data.total || 0;
          this.loading = false;
        })
        .catch(e => {
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
          this.loading = false;
        });
    },
    openDialog() {
      this.formData = {
        Id: 0,
        Name: "",
        Title: "",
        Photo: "",
        Bio: "",
        SortOrder: 0,
        CreateTime: new Date()
      };
      this.dialogFormVisible = true;
    },
    handleCreateOrModify() {
      // 校验
      if (!this.formData.Name || !this.formData.Title) {
        this.$message.warning("姓名和职位为必填项");
        return;
      }

      this.loading = true;
      this.$http
        .put("Expert", this.formData, this.options)
        .then(() => {
          this.loading = false;
          this.$message({
            message: this.formData.Id ? "修改成功！" : "创建成功！",
            type: "success"
          });
          this.dialogFormVisible = false;
          this.loadData();
        })
        .catch(e => {
          this.loading = false;
          this.$message({
            message: "网络或程序异常！" + e,
            type: "error"
          });
        });
    },
    handleEdit(index, row) {
      this.formData = Object.assign({}, row);
      this.dialogFormVisible = true;
    },
    handleDelete(index, row) {
      this.$confirm("此操作将永久删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`Expert/${row.Id}`, this.options)
            .then(() => {
              this.loading = false;
              this.$message({ message: "删除成功！", type: "success" });
              // 如果删的是当前页最后一条且不是首页,自动回退一页
              if (this.tableData.length === 1 && this.page > 1) {
                this.page -= 1;
              } else {
                this.loadData();
              }
            })
            .catch(e => {
              this.loading = false;
              this.$message({
                message: "网络或程序异常！" + e,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    }
  }
};
</script>

<style scoped>
.el-table {
  margin-top: 20px;
}

.pager {
  margin-top: 20px;
  text-align: center;
}

.bio-cell {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: #606266;
  font-size: 12px;
}

.muted {
  color: #c0c4cc;
}
</style>
